import PropTypes from "prop-types";
import React from "react";
import PopupSelectAdapter from "../../PopupSelectAdapter";
import LinkForPopupPropTypes from "../../LinkForPopupPropTypes";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

import '../../../../../stylesheets/react_large_popup_button.scss';

const LinkForPopup = (props) => {
  return (
    <a className="area" onClick={props.onClickPopupLink}>
      <input
        type="text"
        name="input_area_name"
        className="area large"
        placeholder="地域を選択"
        readOnly="readonly"
        value={props.inputValue}
        onChange={props.onChangeInputValue}
      />
    </a>
  );
};

LinkForPopup.propTypes = LinkForPopupPropTypes;

export default LinkForPopup;
